module.exports = __webpack_public_path__ + "assets/img/training-pass-icon.b291d131.png";